import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/work_environment1.png'
import _imports_1 from '@/assets/img/work_environment3.png'
import _imports_2 from '@/assets/img/work_environment2.png'
import _imports_3 from '@/assets/img/work_environment4.png'


const _withScopeId = n => (_pushScopeId("data-v-4d24ed62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-environment" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-4d24ed62>办公环境</div><div class=\"sub-title\" data-v-4d24ed62>OFFICE ENVIRONMENT</div><div class=\"photo\" data-v-4d24ed62><div data-v-4d24ed62><img src=\"" + _imports_0 + "\" style=\"width:511px;\" alt=\"\" data-v-4d24ed62></div><div data-v-4d24ed62><img src=\"" + _imports_1 + "\" style=\"width:383px;\" alt=\"\" data-v-4d24ed62><img src=\"" + _imports_2 + "\" style=\"width:383px;\" alt=\"\" data-v-4d24ed62><img src=\"" + _imports_3 + "\" style=\"width:383px;\" alt=\"\" data-v-4d24ed62></div></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}